import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const ViewClientWrapper = styled.div`
  .accordion-button-container {
    display: grid;
    justify-content: end;
    ${responsive.MOBILE`
      margin-right: 16px;
    `}
  }
  .separator-space {
    margin: 24px 0;
    ${responsive.MOBILE`
      margin: 16px 0 0 0;
    `}
  }
  .bottom-button-container {
    height: 104px;
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0px 16px;
    background-color: ${COLORS.cirrus_white};

    ${responsive.MOBILE`
      width: 100%;
      padding: 16px;
      gap: 12px;
      height: auto;
      flex-direction: column-reverse;
    `}

    .bottom-button-edit, .bottom-button-close {
      ${responsive.MOBILE`
        width: 100%;
        margin: 0;
      `}
    }

    .bottom-button-edit {
      margin-left: 12px;
      ${responsive.MOBILE`
        margin-left: 0;
      `}
    }
  }
`;
